import { KeyboardEvent as ReactKeyboardEvent, useCallback } from "react";

type CommonEvent = { key: string; preventDefault(): void };

// General on key handler, allows specification of set of keys and onKey to
// trigger when any key in that set is pressed
export default function useOnKeyHandler<T = Element>(
  key: Set<string>,
  onKey: () => void
): (event: ReactKeyboardEvent<T>) => void {
  return useOnRawKeyHandler<ReactKeyboardEvent<T>>(key, onKey);
}

export function useOnRawKeyHandler<
  EventType extends CommonEvent = KeyboardEvent
>(key: Set<string>, onKey: () => void): (event: EventType) => void {
  return useCallback(
    (event: EventType) => {
      if (key.has(event.key)) {
        event.preventDefault();
        onKey();
      }
    },
    [key, onKey]
  );
}
